import WysiwygContentBlock from 'models/common/content/block/WysiwygContentBlock';

export default class WysiwygContentBlockService {
	toModel(block) {
		return new WysiwygContentBlock(block);
	}
}
